// components/RegistrationWizard/ConfirmDialog.jsx
import React from "react";

export default function ConfirmDialog({ onCancel, onConfirm, loading }) {
  return (
    <div className="modal-register">
      <div className="modal-card"  onClick={(e) => e.stopPropagation()}>
        <h3>Ertu viss um að allar upplýsingar séu réttar?</h3>
        <div className="modal-actions">
          <button className="ghost" onClick={onCancel} disabled={loading}>Nei</button>
          <button className="primary" onClick={onConfirm} disabled={loading}>
            {loading ? "Skrái…" : "Já, klára skráningu"}
          </button>
        </div>
      </div>
      <div className="backdrop" onClick={onCancel} />
    </div>
  );
}